export class BeneficiarioAp {
    nombre:string
    documento:string
    fechaNacimiento:string
    sexo:string
    eps:string
    matricula:string
    antecedentes:string
}
